import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    NavHeaderBar, NavIconWrapper, NavSideBar, NavSideBarWrapper, NavPadding
} from "../../style/navigation_styles"
import {colorWhite, NavBarsIcon, NavCloseIcon} from "../../style/icons";
import NavigationItem from "src/view/commons/navigationPanel/navigation_item";
import HomeNavItem from "./home_nav_item";
import ConfigPanelNavItem from "./config_panel_nav_item";
import FeatureGenerationNavItem from "./feature_generation_nav_item";
import ModelTrainingNavItem from "./model_training_nav_item";
import {NavItem} from "src/view/commons/navigationPanel/nav_item_commons";
import DatasetNavItem from "./dataset_nav_item";

export const getNavItems = () => {
    return [
        HomeNavItem,
        FeatureGenerationNavItem,
        ModelTrainingNavItem,
        ConfigPanelNavItem,
        DatasetNavItem
    ]
}

export default function NavigationBar() {
    const navigationItems = getNavItems();
    const [sideBar, setSideBar] = useState(false);

    const showSideBar = () => setSideBar(!sideBar);

    const showNavItems = () => {
        if (navigationItems.length > 0) {
            return (
             <>
                 {
                     navigationItems.map((navItem: NavItem, key: number) => {
                         return <NavigationItem key={key} navItem={navItem}  closeSideNav={showSideBar} paddingLevel={0}/>
                     })
                 }
             </>
            )
        }
    }

    return (
        <>
            <NavHeaderBar>
                <NavIconWrapper onClick={showSideBar}>
                    <NavBarsIcon style={colorWhite}/>
                </NavIconWrapper>
            </NavHeaderBar>
            <NavSideBar sidebar={sideBar}>
                <NavSideBarWrapper>
                    <NavIconWrapper onClick={showSideBar}>
                        <NavCloseIcon style={{...colorWhite, float: "right"}}/>
                    </NavIconWrapper>
                    <NavPadding/>
                    {showNavItems()}
                </NavSideBarWrapper>
            </NavSideBar>

        </>
    )


}